import React from 'react';
import PropTypes from 'prop-types';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_ERROR_TRUSTED_PARTY_ENTITLEMENT_CANCELLED_TITLE,
	ONBOARDING_ERROR_TRUSTED_PARTY_ENTITLEMENT_CANCELLED_DESCRIPTION,
} from '../../../../constants/Copy';
import { useParams } from 'react-router';

const DefaultSubscriptionCancelledError = () => {
	const { partnerName } = useParams();

	return (
		<FullPageMessage
			title={ONBOARDING_ERROR_TRUSTED_PARTY_ENTITLEMENT_CANCELLED_TITLE.replaceAll(
				'{trustedParty}',
				partnerName
			)}
			description={ONBOARDING_ERROR_TRUSTED_PARTY_ENTITLEMENT_CANCELLED_DESCRIPTION.replaceAll(
				'{trustedParty}',
				partnerName
			)}
		/>
	);
};

DefaultSubscriptionCancelledError.propTypes = {
	history: PropTypes.object.isRequired,
};

export default DefaultSubscriptionCancelledError;
